// extracted by mini-css-extract-plugin
export default {"component":"i-ETF"};